<template>
<div id="organization-container" >

    <div v-if="loading" class="loading-container">
        <img class="loading-spinner" src="https://www.realclearpolitics.com/asset/img/fact_check/loading.png">
    </div>

    <template v-else >
        <div class="org-name-wrapper">
            <h2 id="organization-name" >{{ organization.name }}</h2>
        </div>

        <div class="org-charts">

            <vertical-chart 
                class="org-chart"
                title="Claims By Subject"
                sub-title="Number of fact checked claims organized by subject"
                start-date=""
                end-date=""
                :data="claims_by_type_data"
                />

            <vertical-chart 
                class="org-chart"
                title="Claim Authors By category"
                sub-title="Number of claim authors by category"
                start-date=""
                end-date=""
                :data="claim_sources_by_type_data"
                />

            <vertical-chart 
                class="org-chart"
                title="Top Claim Authors"
                sub-title="Top sources of claims"
                start-date=""
                end-date=""
                :data="top_claim_sources_data"
                />

            <vertical-chart 
                class="org-chart"
                title="Top Verdicts"
                sub-title=""
                start-date=""
                end-date=""
                :data="top_verdicts_data"
                />

        </div>

        <!-- <div class="fact-checkers-section">
            <h3>Fact Checkers:</h3>

            <div class="fact-checkers-list">
                <vertical-chart 
                    class="float-org-chart"
                    title="Top Verdicts"
                    sub-title=""
                    start-date="2/16/2021"
                    end-date="7/16/2021"
                    :data="top_verdicts_data"
                    />
                <p class="fc-checker-text" >
                    <ul class="fc-checker-list-el" >
                        
                        <li v-for="(checker, checker_index) in fact_checkers_data" :key="`${checker.id}-${checker_index}`" >
                            <router-link v-if="checker.link" :to="checker.link">{{checker.name}}</router-link>
                            <span v-else >{{checker.name}}</span>
                        </li>
                    </ul>
                </p>
            </div>
        </div> -->
        <!-- end fact-checkers section -->
        
    </template>

</div>
</template>

<script>

import VerticalChart from './Charts/VerticalChart.vue';
import ApiMixin from './ApiMixin.js';

export default {
    name: "fc-organizations",
    components: {
        'vertical-chart': VerticalChart,
    },
    mixins: [
        ApiMixin,
    ],
    data() {
        return {

            method: 'organization_data',

            org_slug: '',

            loading: true,

            organization: {},

            claims_by_type_data: [],

            claim_sources_by_type_data: [],

            top_claim_sources_data: [],

            top_verdicts_data: [],

            fact_checkers_data: [],

        };
    },
    created(){

        if( this.$route.query.org ){
            this.org_slug = this.$route.query.org;
        }else if( this.$route.params.org ){
            this.org_slug = this.$route.params.org;
        }

        this.getClaimSourceData();
    },
    methods: {
        async getClaimSourceData(){
            this.loading = true;
            let data = await this.getData({organization: this.org_slug}, this.method);
            console.log("CLAIM SOURCE (AUTHOR)", data);
            this.organization                = data.data.data.organization[0];
            this.claims_by_type_data         = data.data.data.claims_by_type_data;
            this.claim_sources_by_type_data  = data.data.data.claims_by_source_type;
            this.top_claim_sources_data      = data.data.data.top_claims_sources;
            this.top_verdicts_data           = data.data.data.top_verdicts_data;
            // this.fact_checkers_data          = data.data.data.fact_checkers_data;
            this.loading = false;
        },
    },
}
</script>

<style lang="scss">
#organization-container{

    .org-name-wrapper{
        background-color: #DC0000;
        margin-bottom: -20px;

        #organization-name{
            color: #fff;
            padding: 10px 20px;
        }
    }

    .org-charts{
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;

        .org-chart{
            flex-basis: 100%;
        }

        @media screen and (min-width: 768px){
            &{
                flex-direction: row;
                justify-content: space-between;

                .org-chart{
                    flex-basis: 49%;
                }
            }
        }

        @media screen and (min-width: 1024px){
            &{
                .org-chart{
                    flex-basis: 24%;
                }
            }
        }

    }

    .fact-checkers-list {
        // display: flex;
        // justify-content: flex-start;
        // flex-direction: row;
        // flex-wrap: wrap;
        
        // & > *{
        //     flex-basis: 30%;
        //     padding: 5px;
        // }

        & a{
            color: blue;
        }
    }

    .fact-checkers-section{

        .fact-checkers-list{

            .float-org-chart{
                float:right;
                width: 300px;
            }

            .fc-checker-text{

                .fc-checker-list-el{
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    padding-inline-start: 0px;
                    li{
                        flex-basis: 250px;
                        padding: 10px 10px;
                    }
                }
            }
        }
    }
}
</style>